/* Everything the page script does not own: the paid add-ons, the lighting option, the drawing of
   the composition, the dimension drawing, the zoom, and the quotation form that arrives filled in.

   Two things about this theme decide the shape of this file. The page script binds every .it__thumb
   that exists at start-up, so the sketch tab is created here, afterwards, or it would be treated as
   a photograph. And layout/theme.liquid replaces Element.prototype.scrollIntoView with a function
   that returns null, so scrolling has to go through window.scrollTo. */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* The theme sizes every thumbnail as a square, so the two text tabs get a width that follows
     their own label instead of being cropped by it. */
  var CSS = '.it__thumb--txt{width:auto!important;min-width:0!important;padding:0 14px!important;'
    + 'white-space:nowrap;display:inline-flex;align-items:center;justify-content:center}';
  (function () {
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);
  })();

  function goTo(node, offset) {
    if (!node) return;
    var y = node.getBoundingClientRect().top + window.pageYOffset - (offset || 90);
    window.scrollTo({ top: y, behavior: REDUCED ? 'auto' : 'smooth' });
  }
  function payload(id) {
    var node = document.getElementById('it-data-' + id);
    if (!node) return {};
    try { return JSON.parse(node.textContent); } catch (e) { return {}; }
  }

  /* ---- the lighting option ----
     A real variant, so the price comes from Shopify and not from this script. Picking one loads
     that variant's own URL, which is what keeps the price, the payload and the cart form in step. */
  function lighting(root) {
    var radios = [].slice.call(root.querySelectorAll('[data-it-variant]'));
    if (radios.length < 2) return;
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        var url = r.getAttribute('data-it-variant');
        if (url) window.location.href = url;
      });
    });
  }

  /* ---- the paid add-ons: several cart lines in one order ---- */
  function addons(root, id) {
    var boxes = [].slice.call(root.querySelectorAll('[data-it-addon]'));
    if (!boxes.length) return;

    var labels = [];
    boxes.forEach(function (b) {
      var l = b.parentNode;
      while (l && l !== root && String(l.className).indexOf('it__addon') < 0) l = l.parentNode;
      if (l && l !== root) labels.push(l);
    });
    if (labels.length > 1 && 'MutationObserver' in window) {
      var lead = labels[0];
      new MutationObserver(function () {
        labels.slice(1).forEach(function (l) { l.hidden = lead.hidden; });
      }).observe(lead, { attributes: true, attributeFilter: ['hidden'] });
    }

    var form = root.querySelector('#it-cartform-' + id + ' form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      var on = boxes.filter(function (b) { return b.checked; });
      if (!on.length) return;
      var main = form.querySelector('input[name=id]');
      if (!main) return;
      e.preventDefault();

      var props = {};
      root.querySelectorAll('#it-props-' + id + ' input').forEach(function (i) {
        props[i.name.replace(/^properties\[/, '').replace(/\]$/, '')] = i.value;
      });
      var items = [{ id: Number(main.value), quantity: 1, properties: props }];
      on.forEach(function (b) { items.push({ id: Number(b.getAttribute('data-it-addon')), quantity: 1 }); });

      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        window.location.href = ROOT + 'cart';
      }).catch(function () {
        on.forEach(function (b) { b.checked = false; });
        form.submit();
      });
    });
  }

  /* ---- the dimension drawing ----
     One scale for all three measurements: the composition seen from the front, and beside it the
     same composition seen from the side, which is the only honest way to draw a depth. */
  function plan(root, id) {
    var svg = document.getElementById('it-plan-' + id);
    if (!svg) return;
    var size = payload(id).size || {};
    var w = Number(size.w) || 0, h = Number(size.h) || 0, d = Number(size.d) || 0;
    if (!w || !h) return;

    var FRONT_W = 600, FRONT_X = 90, SIDE_W = 140, SIDE_X = 800, FLOOR = 380, MAX_H = 320;
    var sc = Math.min(MAX_H / h, FRONT_W / w);
    var bw = w * sc, bh = h * sc, dw = Math.max(d * sc, 14);
    var bx = FRONT_X + (FRONT_W - bw) / 2, by = FLOOR - bh;
    var sx = SIDE_X + (SIDE_W - dw) / 2;

    var set = function (sel, attrs) {
      var n = svg.querySelector(sel);
      if (!n) return;
      for (var k in attrs) n.setAttribute(k, attrs[k]);
    };
    set('[data-e-box]', { x: bx, y: by, width: bw, height: bh });
    set('[data-s-box]', { x: sx, y: by, width: dw, height: bh });
    set('[data-x-wl]', { x1: bx, x2: bx });
    set('[data-x-wr]', { x1: bx + bw, x2: bx + bw });
    set('[data-x-ht]', { x1: bx, y1: by, y2: by });
    set('[data-x-hb]', { x1: bx });
    set('[data-x-dl]', { x1: sx, x2: sx });
    set('[data-x-dr]', { x1: sx + dw, x2: sx + dw });
    set('[data-d-w]', { x1: bx, x2: bx + bw });
    set('[data-d-h]', { y1: by, y2: FLOOR });
    set('[data-d-d]', { x1: sx, x2: sx + dw });
    set('[data-l-w]', { x: bx + bw / 2 });
    set('[data-l-h]', { y: by + bh / 2, transform: 'rotate(-90 28 ' + (by + bh / 2) + ')' });
    set('[data-l-d]', { x: sx + dw / 2 });
    if (!d) {
      ['[data-s-box]', '[data-s-floor]', '[data-x-dl]', '[data-x-dr]', '[data-d-d]', '[data-l-d]']
        .forEach(function (sel) { var n = svg.querySelector(sel); if (n) n.setAttribute('display', 'none'); });
    }
  }

  /* ---- the drawing of the composition: one band per part, in the material chosen right now ---- */
  function sketch(root, id) {
    var pane = document.getElementById('it-scheme-' + id);
    var rows = document.getElementById('it-rows-' + id);
    var thumbs = document.getElementById('it-thumbs-' + id);
    var img = document.getElementById('it-img-' + id);
    var plandr = document.getElementById('it-plan-' + id);
    // The section styles .it__scheme with display:flex, and that outranks the browser rule for
    // [hidden]. Without this line the empty panel lies on top of the photograph.
    if (pane) pane.style.display = 'none';
    var label = root.querySelector('.it__scheme-label');
    if (!pane || !rows || !thumbs || !label) return;

    var tab = document.createElement('button');
    tab.type = 'button';
    tab.className = 'it__thumb it__thumb--txt';
    tab.textContent = label.textContent;
    tab.setAttribute('aria-pressed', 'false');
    thumbs.appendChild(tab);

    function draw() {
      pane.textContent = '';
      [].slice.call(rows.querySelectorAll('.it__row')).forEach(function (r) {
        var sw = r.querySelector('.sw');
        var band = document.createElement('span');
        band.style.backgroundImage = sw ? sw.style.backgroundImage : '';
        var b = document.createElement('b');
        b.textContent = r.querySelector('.part').textContent;
        var em = document.createElement('em');
        em.textContent = r.querySelector('.name').textContent;
        band.appendChild(b);
        band.appendChild(em);
        pane.appendChild(band);
      });
    }

    function show(on) {
      if (!on) { pane.setAttribute('hidden', ''); pane.style.display = 'none'; return; }
      draw();
      pane.removeAttribute('hidden');
      pane.style.display = 'flex';
      if (img) img.setAttribute('hidden', '');
      if (plandr) plandr.setAttribute('hidden', '');
      thumbs.querySelectorAll('.it__thumb').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      tab.setAttribute('aria-pressed', 'true');
    }

    tab.addEventListener('click', function () { show(true); });
    thumbs.addEventListener('click', function (e) { if (e.target !== tab) show(false); });
    if ('MutationObserver' in window) {
      new MutationObserver(function () { if (!pane.hasAttribute('hidden')) draw(); })
        .observe(rows, { subtree: true, childList: true, characterData: true, attributes: true });
    }
  }

  /* ---- the quotation form arrives filled in ----
     The customer said all of this on the way down the page. Repeating the question would be the
     one thing that stops them sending it, so the answers are already there and every one of them
     stays editable. The message is only written while the customer has not touched it. */
  function quote(root, id) {
    var form = root.querySelector('#it-quote-' + id + ' form');
    if (!form) return;
    var data = payload(id);
    var t = data.t || {};

    var msg = document.getElementById('it-msg-' + id);
    var touched = false;
    if (msg) msg.addEventListener('input', function () { touched = true; });

    var instBox = root.querySelector('#it-install-' + id);
    var instSel = form.querySelector('[data-it-instsel]');
    function mirror() {
      if (!instBox || !instSel) return;
      instSel.selectedIndex = instBox.checked ? 1 : 0;
    }
    if (instBox && instSel) instBox.addEventListener('change', mirror);
    mirror();

    function fill() {
      if (!msg || touched) return;
      var body = document.getElementById('it-body-' + id);
      // the page script already wrote the composition, its address and the materials into the
      // hidden field, so the visible message says the same thing rather than a second version of it
      msg.value = body && body.value ? body.value : (t.sumNone || '');
    }
    fill();
    var rows = document.getElementById('it-rows-' + id);
    if (rows && 'MutationObserver' in window) {
      new MutationObserver(fill).observe(rows, { subtree: true, childList: true, characterData: true, attributes: true });
    }

    form.addEventListener('submit', function () {
      var b = form.querySelector('button[type=submit]');
      if (!b || b.disabled) return;
      b.disabled = true;
      if (b.getAttribute('data-busy')) b.textContent = b.getAttribute('data-busy');
      setTimeout(function () { b.disabled = false; }, 8000);
    });
  }

  /* ---- a chosen part sends you to the range, and the photograph opens full size ---- */
  function navigate(root, id) {
    var rows = document.getElementById('it-rows-' + id);
    var tabs = document.getElementById('it-tabs-' + id);
    if (rows && tabs) {
      rows.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.it__row')) {
          setTimeout(function () { goTo(tabs); }, 60);
        }
      });
    }

    var frame = root.querySelector('.it__frame');
    var img = document.getElementById('it-img-' + id);
    if (!frame || !img) return;

    var box = document.createElement('div');
    box.className = 'it__zoom';
    var big = document.createElement('img');
    big.alt = '';
    box.appendChild(big);
    root.appendChild(box);

    function close() {
      box.classList.remove('on');
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    img.addEventListener('click', function () {
      if (img.hasAttribute('hidden')) return;
      big.src = img.currentSrc || img.src;
      big.alt = img.alt || '';
      box.classList.add('on');
      document.addEventListener('keydown', onKey);
    });
    box.addEventListener('click', close);
  }

  function wire(root) {
    if (root.getAttribute('data-it-addons')) return;
    root.setAttribute('data-it-addons', '1');
    var id = root.getAttribute('data-it');
    lighting(root);
    addons(root, id);
    plan(root, id);
    sketch(root, id);
    quote(root, id);
    navigate(root, id);
  }

  function boot() { document.querySelectorAll('[data-it]').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
